import { createStore, applyMiddleware, compose } from "redux";
import { browserHistory } from "react-router";
import createSagaMiddleware from "redux-saga";
// import freeze from "redux-freeze";
import { reducers } from "./reducers/index";
import axios from "axios";
import axiosMiddleware from "redux-axios-middleware";
import config from './config'

const client = axios.create({
  baseURL: config.apiUrl,
  responseType: "json",
});

// add the middlewares
let middlewares = [];

// add the router middleware
// middlewares.push(routerMiddleware(browserHistory));

// add the redux-axios-middleware
middlewares.push(axiosMiddleware(client));

// // add the saga middleware
const sagaMiddleware = createSagaMiddleware();
middlewares.push(sagaMiddleware);

// // add the freeze dev middleware
// if (process.env.NODE_ENV !== 'production') {
//   // middlewares.push(freeze);
// }

// apply the middleware
let middleware = applyMiddleware(...middlewares);

// add the redux dev tools
if (process.env.NODE_ENV !== "production" && window.devToolsExtension) {
  middleware = compose(middleware, window.devToolsExtension());
}

// create the store
const store = createStore(reducers, middleware);
const history = browserHistory;

// export
export { store, history };



// WEBPACK FOOTER //
// ./client/store.js